import React from 'react'
import Fragment from '../common/fragment'


function FragmentAW(props) {
  return (
    <Fragment pos="w" {...props}>
      <p>
Las abejas predicarán en torno al Muñeco. Como los evangélicos en la plaza, el
Muñeco presenciará la Nada.
      </p>
    </Fragment>
  )
}


export default FragmentAW
